import Tooltip from '@mui/material/Tooltip';
import { type FC, memo, useState, useCallback, type SyntheticEvent } from 'react';
import { checkOverflow } from '../../../../utils/utilFunctions';
import StyledWrapper from '../style';

interface CellValues {
	formattedValue?: string;
	field?: string;
	id?: string | number;
}

interface BasicCellTextProps {
	cellValues: CellValues;
	disabled?: boolean;
}

const BasicCellTextComponent: FC<BasicCellTextProps> = ({ cellValues, disabled }) => {
	const [isOpen, setIsOpen] = useState(false);

	const formattedText = cellValues?.formattedValue;

	const handleOpen = useCallback((e: SyntheticEvent) => {
		checkOverflow(e) && setIsOpen(true);
	}, []);

	const handleClose = useCallback(() => {
		setIsOpen(false);
	}, []);

	return (
		<Tooltip
			open={isOpen}
			onOpen={handleOpen}
			onClose={handleClose}
			arrow
			placement="top"
			title={formattedText}
		>
			<StyledWrapper.CellContainer
				data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
			>
				<StyledWrapper.CardRowInfoText
					data-testid={`rowInfo-${cellValues?.field}-${cellValues?.id}`}
					disabled={disabled}
				>
					{formattedText}
				</StyledWrapper.CardRowInfoText>
			</StyledWrapper.CellContainer>
		</Tooltip>
	);
};

const BasicCellText = memo(BasicCellTextComponent, (prevProps, nextProps) => {
	return (
		prevProps.cellValues?.formattedValue === nextProps.cellValues?.formattedValue &&
		prevProps.cellValues?.field === nextProps.cellValues?.field &&
		prevProps.cellValues?.id === nextProps.cellValues?.id &&
		prevProps.disabled === nextProps.disabled
	);
});

BasicCellText.displayName = 'BasicCellText';

export default BasicCellText;
